import { useState } from "react";

const useSelect = (data) => {

    const [selected, setSelected] = useState([])

    const onSelectAll = () => {
        if (data) {
            let every = data?.every(element => selected.includes(element._id));
            if (!every) {
                setSelected(data?.map(item => item._id))
            } else {
                setSelected([])
            }
        }
    }

    const onSelectRow = (id) => {

        let index = selected.indexOf(id)

        if (index > -1) {
            let data = [...selected]
            data.splice(index, 1);
            setSelected(data)
        } else {
            setSelected(prev => [...prev, id])
        }

    }

    const checkExist = (id) => selected.includes(id)

    return {
        isAllSelected: data?.every(element => selected.includes(element._id)),
        totalSelected: selected?.length,
        isExists: checkExist,
        onSelectAll,
        onSelectRow
    }

}

export default useSelect